import { onBeforeUnmount, shallowRef } from 'vue'
import type { ShallowRef } from 'vue'
import type { VueHeadClient } from '@unhead/vue'

export function resolvePageTitle(head: Pick<VueHeadClient, 'entries'>): string | undefined {
    let title: string | undefined
    for (const entry of head.entries.values()) {
        const entryTitle = entry.input?.title
        if (typeof entryTitle === 'string' && entryTitle !== '') {
            title = entryTitle
        }
    }

    return title
}

export function usePageTitle(): Readonly<ShallowRef<string | undefined>> {
    const head = injectHead()
    const pageTitle = shallowRef(resolvePageTitle(head))

    const unhook = head.hooks.hook('tags:afterResolve', () => {
        pageTitle.value = resolvePageTitle(head)
    })

    onBeforeUnmount(() => {
        unhook()
    })

    return pageTitle
}
